export default "__VITE_ASSET__47a49ff3__"